import * as types from './mutation-types'

export default {
  [types.SET_SHOP_INFO] (state, shopInfo) {
    state.shopInfo = shopInfo;
  },
  [types.SET_USER_INFO] (state, user) {
    state.authUser = user;
  },
  [types.SET_CART] (state, cart) {
    state.cart = cart;
  },
  [types.SET_CHECKOUT_INFO] (state, checkoutInfo) {
    state.checkoutInfo = checkoutInfo;
  },
}
